import {connect} from 'react-redux';

import {CellsContext} from '../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {resubscribeAllVisitorNotificationsAction} from '../../../store/data/preferences/preferencesActions';
import {getIsVisitorSubscribedAll} from '../../../store/data/preferences/preferencesSelectors';
import {getUserId} from '../../../store/data/teammates/teammatesSelectors';
import {InboxesVisualConversationSelection} from '../../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {makeGetOnlySelectedConversation} from '../../../store/panels/cells/selectors/cellsPanelSelectionSelectors';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {VisitorConversationsHeader} from './visitorConversationsHeader';

/*
 * Props.
 */

interface VisitorConversationsHeaderContainerProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  conversationSelection: InboxesVisualConversationSelection;
}

/*
 * Selectors.
 */

function getConversationSelection(_state: AppState, props: VisitorConversationsHeaderContainerProps) {
  return props.conversationSelection;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<VisitorConversationsHeaderContainerProps>()(() => {
  const getOnlySelectedConversation = makeGetOnlySelectedConversation(getConversationSelection);

  return {
    userId: getUserId,
    conversation: getOnlySelectedConversation,
    isVisitorSubscribedAll: getIsVisitorSubscribedAll,
  };
});

export const VisitorConversationsHeaderContainer = connect(mapStateToProps, {
  resubscribeAllVisitorNotifications: resubscribeAllVisitorNotificationsAction,
})(VisitorConversationsHeader);
